import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { Auction } from '../../_interfaces/auction.interface';
import { AuctionService } from '../../_services/auction/auction.service';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';
import { BuyerAuthService } from 'src/app/app-modules/buyer/buyer-core/buyer-authentication/services/buyer-auth/buyer-auth.service';
import { BuyerService } from 'src/app/app-modules/buyer/_services/buyer/buyer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

import { PusherService } from 'src/app/Shared/services/pusher/pusher.service';
import {
  getPaginationData,
  CardsPerPage,
} from 'src/app/_utlis/pagination-helper';
import { IPagination } from 'src/app/Shared/_models/pagination.model';
import { PageHeaderComponent } from '../../../../../../Shared/components/page-header/page-header.component';
import { BuyerPageOptionsComponent } from '../../../../buyer-shared/components/buyer-page-options/buyer-page-options.component';
import { SearchInputComponent } from '../../../../../../Shared/components/search/search-input.component';
import { PaginationResultsComponent } from '../../../../../../Shared/components/pagination-results/pagination-results.component';
import { ReactiveFormsModule } from '@angular/forms';

import { BuyerAuctionCardComponent } from '../../../../buyer-shared/components/buyer-auction-card/buyer-auction-card.component';
import { NoDataComponent } from '../../../../../../Shared/components/no-data/no-data.component';
import { PaginationComponent } from '../../../../../../Shared/components/pagination/pagination.component';
import { isPlatformBrowser } from '@angular/common';
import { TranslatePipe, TranslateService} from '@ngx-translate/core';
import { Breadcrumb } from 'src/app/Shared/_models/breadcrumb.model';
import { getAuctionChannels } from '../../_PusherEvents/auction-pusher-events';
import * as Events from 'src/app/_contstants/pusher-contstants';
import { IAuctionUpdateEventPayload } from 'src/app/Shared/_models/pusher-events-payload.model';
import { StorageService } from 'src/app/Core/_services/storage/storage.service';

@Component({
    selector: 'app-buyer-previous-auctions',
        standalone: true,
templateUrl: './buyer-previous-auctions.component.html',
    styleUrls: ['./buyer-previous-auctions.component.scss'],
    imports: [
    PageHeaderComponent,
    BuyerPageOptionsComponent,
    SearchInputComponent,
    PaginationResultsComponent,
    ReactiveFormsModule,
    BuyerAuctionCardComponent,
    NoDataComponent,
    PaginationComponent,
    TranslatePipe
]
})
export class BuyerPreviousAuctionsComponent {
  isLoading!: boolean;
  auctionType = 'previous';
  searchVal = '';
  auctions: Auction[] = [];
  loggedIn = false;
  // sub!: Subscription;
  breadcrumbs: Breadcrumb[] = [];
  currentLang: any;
  timer!: any;

  page: number = 1;
  itemsPerPage: number = CardsPerPage;

  paginationData!: {
    totalPages: number;
    total: number | undefined;
    from: number | undefined;
    to: number | undefined;
  };
  calledFirstTime!: boolean;
  isBrowser: boolean;
  private subscriptions = new Subscription();

  constructor(
    private auctionService: AuctionService,
    private toastService: ToastService,
    private auth: BuyerAuthService,
    private buyerService: BuyerService,
    private router: Router,
    private titleService: Title,
    private translate: TranslateService,
    private pusherService: PusherService,
    private route: ActivatedRoute,
    private meta: Meta,
    private storageService: StorageService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.initializeMetaTags();

    this.isBrowser = isPlatformBrowser(this.platformId);

    if (this.isBrowser) {
      this.currentLang = JSON.parse(
        localStorage.getItem(this.storageService.getPrefixedKey('selectedLang')) ?? '{}'
      );
    }
  }
  ngOnInit(): void {
    this.initializeAuthSubscription();

    this.initializeRouteSubscription();
  }

  initializeMetaTags() {
    this.titleService.setTitle('Previous Horse Auctions at bidxsell ');
    this.meta.addTag({
      name: 'description',
      content:
        'Explore our horse auctions and find your perfect equine companion. Browse available horses, place your bids, and experience a seamless auction process.',
    });
  }

  initializeAuthSubscription() {
    const authSub = this.auth.loggedIn_authorized$.subscribe((res) => {
      this.loggedIn = res;
      if (this.calledFirstTime) {
        this.getAuctions();
      }
      this.unSubscribeFromChannels();
      this.subscribeToChannels();
    });
    this.subscriptions.add(authSub);
  }
  initializeRouteSubscription() {
    const routeSub = this.route.queryParams.subscribe((params) => {
      this.page = +params['page'];
      this.searchVal = params['search'] || '';
      this.getAuctions();
    });
    this.subscriptions.add(routeSub);
  }
  resetSearch() {
    this.router.navigate(['/buyer/auctions/previous']);
  }
  getAuctions(reload = true) {
    this.calledFirstTime = true;

    this.toastService.clear();
    if (reload) {
      this.isLoading = true;
    }
    this.auctionService
      .getPreviousAuctions(this.searchVal, this.page || 1, this.itemsPerPage)
      .subscribe({
        next: (response: {
          data: { items: Auction[]; pagination: IPagination };
        }) => {
          this.auctions = response.data.items;
          this.paginationData = getPaginationData(
            response.data.pagination,
            this.itemsPerPage
          );
        },
        error: (error) => {
          this.toastService.showError(error?.error?.Error[0]);
        },
        complete: () => {
          this.isLoading = false;
        },
      });
  }

  handleSearch(search: string) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      const queryParams: any = { search };

      this.router.navigate(['/buyer/auctions/previous'], { queryParams });
    }, 1500);
  }
  onPageChanged(page: number): void {
    const queryParams: any = { page };
    if (this.searchVal) {
      queryParams.search = this.searchVal;
    }

    this.router.navigate(['/buyer/auctions/previous'], {
      queryParams,
    });
  }
  cardClicked(e: any, item: any) {
    e.stopPropagation();

    const queryParams = {
      auctionTypePage: 'previous',
    };
    this.router.navigate(['/buyer/auctions', item.slug], { queryParams });
  }

  subscribeToChannels() {
    const channels = getAuctionChannels(null);

    this.pusherService.subscribeToMultiChannels(channels, (data: any) => {
      this.handlePusherEvents(data);
    });
  }

  handlePusherEvents(eventData: { eventName: string; data: any }) {
    const { eventName, data } = eventData;
    switch (eventName) {
      case Events.AUCTION_UPDATED:
        this.handleAuctionUpdate(data);
        break;
    }
  }

  handleAuctionUpdate(data: IAuctionUpdateEventPayload) {
    const auctionIn = this.auctions.findIndex(
      (el) => el?.id == data?.auction_id
    );

    if (auctionIn === -1) {
      this.getAuctions(false);
    }
  }

  unSubscribeFromChannels() {
    const channels = getAuctionChannels(null).map((el) => el.channelName);

    if (channels.length) {
      this.pusherService.unsubscribeFromChannels(channels);
    }
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.unSubscribeFromChannels();

    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}
